export const getPlanningCardBackground = (isActive: boolean, isOverlappingDays: boolean) => {
  if (!isActive) {
    return "rgba(128,128,128,0.3)";
  }

  if (isOverlappingDays) {
    return "rgba(255,0,0,0.2)";
  }

  return "inherit";
};
